import React, { ReactElement } from 'react';
import Header from './header';

export function Layout({ children }: { children: ReactElement }) {
  return (
    <div className="layout">
      <Header hostName={''} />
      {children}
    </div>
  );
}
